<template>
  <v-dialog
    v-model="showDialog"
    max-width="700"
    persistent
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-show="isVisible"
        :color="color"
        :class="buttonClasses"
        :loading="loading"
        :large="large"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon
          v-if="iconLeft"
          left
        >
          {{ icon }}
        </v-icon>
        Projekt freigeben
        <v-icon
          v-if="iconRight"
          right
        >
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>
    <v-card
      v-if="!loading"
      :loading="submitting"
    >
      <v-card-title>
        <span class="text-h5">
          Projekt {{ project.projektId }} - {{ project.name }}
        </span>
      </v-card-title>
      <v-card-text>
        Soll das Projekt von
        <span
          class="bold"
          :style="{ color: currentProjectStatus.color }"
        >{{ currentProjectStatus.description }}</span>
        auf den Status
        <span
          class="bold"
          :style="{ color: nextProjectStatus.color }"
        >{{ nextProjectStatus.description }}</span>
        gestellt werden? <br />
        Hiermit wird das Projekt freigegeben und ein SPOT-Prozess gestartet.
        Im nächsten Schritt geht das Projekt zur weiteren Bearbeitung an die Planungsabteilung.
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="warning"
          text
          :disabled="submitting"
          @click="submit"
        >
          Projekt freigeben
        </v-btn>
        <v-btn
          color="primary"
          text
          :disabled="submitting"
          @click="showDialog = false"
        >
          Schließen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { adminGroups } from '@/main/routes.js';
import { HTTP } from '@/main/httpClient.js';
import { mdiTagCheck } from '@mdi/js';

import NotificationObject from '@/main/NotificationObject.js';

const EXPECTED_PROJECT_STATUS = 'project-candidate';
const NEXT_PROJECT_STATUS = 'project-approved';

export default {
  name: 'StartProjectChainButton',
  props: {
    project: { type: Object, required: true },
    projectStatuses: { type: Array, required: false, default: null },
    color: { type: String, default: 'green' },
    buttonClasses: { type: String, default: 'white--text' },
    iconLeft: { type: Boolean, default: false },
    iconRight: { type: Boolean, default: false },
    icon: { type: String, default: mdiTagCheck },
    large: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data: () => ({
    showDialog: false,
    loading: false,
    submitting: false,
    submitSuccess: false,
    nextProjectStatus: {}
  }),
  computed: {
    currentProjectStatus() {
      return this.project && this.project.projectStatus;
    },
    isAdmin() {
      return this.$auth
        .user()
        .userRoles.some((role) => adminGroups.includes(role));
    },
    isVisible() {
      return (
        !this.submitSuccess &&
        this.isAdmin &&
        this.currentProjectStatus.name === EXPECTED_PROJECT_STATUS
      );
    }
  },
  watch: {
    project: {
      deep: true,
      handler() {
        this.submitSuccess = false;
      }
    }
  },
  async mounted() {
    if (this.projectStatuses === null) {
      await this.fetchProjectStatuses();
    } else {
      this.nextProjectStatus = this.projectStatuses.find(
        (s) => s.name === NEXT_PROJECT_STATUS
      );
    }

    if (
      !this.nextProjectStatus ||
      this.nextProjectStatus.name !== NEXT_PROJECT_STATUS
    ) {
      console.warn(this.nextProjectStatus);
      throw new Error('Could not fetch next project status');
    }

    this.loading = false;
  },
  methods: {
    fetchProjectStatuses() {
      this.loading = true;
      return HTTP.get(
        '/past/projectStatuses?where[name][equals]=' + NEXT_PROJECT_STATUS
      )
        .then((response) => {
          this.nextProjectStatus = response.data[0];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    submit() {
      this.submitting = true;
      HTTP.post('/productAvailabilityTool/startPlanningAndConstructionStatus', {
        projectId: this.project.projektId
      })
        .then(({ status }) => {
          if (status === 204) {
            this.showMessage('Das Projekt wurde erfolgreich freigegeben');
            this.$emit('submitSuccess', this.project.projektId, true);
            this.submitSuccess = true;
            this.showDialog = false;
          }
        })
        .catch((err) => {
          this.showMessage('Projekt konnte nicht freigegeben werden', 'error');
          console.error(err.response.data, err);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    showMessage(message, type = 'success') {
      this.$store.commit(
        'addNotification',
        new NotificationObject(type, message)
      );
    }
  }
};
</script>
